import * as d3 from "d3";
import {colonAnnotation, numberFormat} from '../functions'

export default function (chart, divId, vizName, resData) {

    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    // axios.post(url, filterParam).then(response => {
        let data = resData

        // Nest the entries by symbol
        var states = d3.nest().key(function (d) {
            return d.dim1_name;
        }).sortKeys(d3.ascending).entries(data)

        console.log(states)

        // Nest the entries by symbol
        var dNest = d3.nest()
            .key(function (d) {
                return d.dim1_name;
            }).sortKeys(d3.ascending)
            .key(function (d) {
                return d.dim3_name;
            })
            .entries(data);

        var legendtext = dNest[0].values.map(function (d) {
            return d.key
        })

        console.log("legendtext", legendtext)

        console.log(dNest)

        dNest.forEach(function (d) {
            d.values.forEach(function (d) {
                d.values.forEach(function (d) {
                    d.dim2_name = new Date(d.dim2_name);
                    d.metric1 = +d.metric1;
                    console.log("date", d.dim2_name)

                });
            })
        });

        // Set the x and y values
        var x = d3.scaleTime().range([0, chart.width]);


        //Format d.date variable
        var formatTime = d3.timeFormat("%Y-%m");

        // Define the axes
        var xAxis = d3.axisBottom(x).tickFormat(formatTime)


        x.domain(d3.extent(data, function (d) {
            return d.dim2_name;
        }));

        var div = d3.select(divId)
        div.selectAll("*").remove();

        // Adds the canvas
        div = d3.select(divId).selectAll("svg")
            .data(dNest)
            .enter()
            .append("svg")
            .attr("width", chart.width + chart.margin.left + chart.margin.right)
            .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
            .attr("font", "Arial")
            .style("font-size", "14px")
            .append("g")
            .attr("transform",
                "translate(" + chart.margin.left + "," + chart.margin.top + ")")
            .attr("id", function (d) {
                console.log("div ", d.key);
                return d.key;
            })

        states.forEach(function (d) {
            //CSS.escape(id) - will escape special character in id/key
            var div = d3.select("#" + CSS.escape(d.key));

            var y = d3.scaleLinear().range([chart.height, 0]);
            var y2 = d3.scaleLinear().range([chart.height, 0]);

            y.domain([
                (function() {
                    var minVal = d3.min(d.values, function(d) {
                        return d.metric1;
                    });
                    return (minVal < 0) ? minVal : 0;
                })(),
                d3.max(d.values, function(d) {
                    return d.metric1; // Maximum value in the data
                })
            ]);
            y2.domain([
                (function() {
                    var minVal = d3.min(d.values, function(d) {
                        return d.metric2;
                    });
                    return (minVal < 0) ? minVal : 0;
                })(),
                d3.max(d.values, function(d) {
                    return d.metric2; // Maximum value in the data
                })
            ]);

            var yAxis = d3.axisLeft(y).tickFormat(numberFormat);
            var y2Axis = d3.axisLeft(y2).tickFormat(numberFormat);

            // Add the div for the tooltip
            var div1 = d3.select("body").append("div1").attr("class", "tooltip").style("opacity", 0);

            var metric1ColorScale = d3.scaleOrdinal(d3.schemeCategory10)

            // Add <defs> and <clipPath> to the SVG
            div.append("defs")
                .append("svg:clipPath")
                .attr("id", "clip1")  // Use d.key for the clipPath id
                .append("svg:rect")
                .attr("x", 0)
                .attr("y", -10)
                .attr("width", chart.width)   // Clip width matches chart width
                .attr("height", chart.height+10); // Clip height matches chart height

            // Append a group with clipPath applied
            const contentGroup = div.append("g")
                .attr("class", "content")
                .attr("clip-path", "url(#clip1)");  // Dynamically set clip-path using d.key

            // var color = function(d) {
            //     return d =='accidents' ? "blue" : d == 'Fatal' ? "red" : d =='Injuries' ? "orange" : metric1ColorScale(d);
            // }
            // // set the colour scale
            // var metric2ColorScale =  d3.scaleOrdinal().range(color)

            // Add the X Axis
            div.append("g")
                .attr("class", "x-axis")
                .attr("transform", "translate(0," + chart.height + ")")
                .call(xAxis);

            //adding axis labels
            div.append("text")
                .attr("transform", "translate(" + (chart.width / 2) + " ," + (chart.height + chart.margin.top + 35) + ")")
                .style("text-anchor", "middle")
                .attr("font-size", "15px")
                .style('fill', 'blue')
                .text(chart.x1AxisDisplayName);

            // Add the Y Axis
            div.append("g").attr("class", "y1-axis").call(yAxis);

            div.append("text")
                .attr("transform", "rotate(-90)")
                .attr("x", -40)
                .attr("y", 65)
                .attr("dy", "-8em")
                .style("text-anchor", "end")
                .attr("font-size", "15px")
                .style('fill', 'blue')
                // .style('display', 'none')
                .text(chart.y1AxisDisplayName);

            div.append("g")
                .attr("class", "y2-axis")
                .attr("transform", "translate(" + chart.width + " ,0)")
                .call(y2Axis)

            div.append('text')
                .attr('transform', 'rotate(-90)')
                .attr('x', 0 - (chart.height / 2) + 160)
                .attr('y', chart.width + chart.margin.right + 10)
                .attr('dy', '1em')
                .style('text-anchor', 'end')
                .attr("font-size", "15px")
                .style('fill', 'blue')
                .text(chart.y2AxisDisplayName)


            div.append("g")
                .append("text")
                .attr("x", -40)
                .attr("y", chart.height / 1.5)
                .attr("dy", "-9em")
                .attr("text-anchor", "start")
                .attr("font-size", "1.1em")
                //  .style("fill",function(d) { return color(d.key) })
                .text(function (d) {
                    return d.key
                });

            /* div.append("g")
                .append("text")
                .attr('transform', 'rotate(90)')
                .attr("x", chart.width + 25)
                .attr("y", chart.height/2.5)
                .attr("dy", ".71em")
                .attr("text-anchor", "start")
                .attr("font-size", "1.1em")
                .text(function(d) { return d.key})*/

            // Loop through each symbol / key
            var lines = contentGroup.selectAll(".line")
                .data(function (d) {
                    return d.values
                })
                .enter()
                .append("path")
                .attr("class", "line")
                .style("stroke", function (d) { // Add the colours dynamically
                    return d.key == 'accidents' ? "blue" : d.key == 'Fatal' ? "red" : d.key == 'Injuries' ? "orange" : metric1ColorScale(d.key);
                })
                // .attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                .attr("stroke-width", 2)
                .attr("fill", "none")
                .attr('d', (d) => {
                    let line = d3.line()
                        .x(d => {
                            return x(d.dim2_name)
                        })
                        .y(d => {
                            return y(+d.metric1)
                        })

                    return line(d.values)
                })

            var lines2 = contentGroup.selectAll(".plotdashed")
                .data(function (d) {
                    return d.values
                })
                .enter()
                .append("path")
                .attr('class', 'plotdashed')
                .style("stroke", function (d) { // Add the colours dynamically
                    return d.key == 'accidents' ? "blue" : d.key == 'Fatal' ? "red" : d.key == 'Injuries' ? "orange" : metric1ColorScale(d.key);
                })
                // .attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                .attr("stroke-width", 2)
                .attr("fill", "none")
                .attr('d', (d) => {
                    let line2 = d3.line()
                        .x(d => {
                            return x(d.dim2_name)
                        })
                        .y(d => {
                            return y2(+d.metric2)
                        })

                    return line2(d.values)
                })

            console.log(lines)
            console.log(lines2)
            // Add the dots for the tooltip
            contentGroup.selectAll(".dot")
                .data(function () {
                    return d.values
                })
                .enter().append("circle")
                .attr("class","dot")
                .attr("r", 5)
                .attr("cx", function (d) {
                    return x(d.dim2_name);
                })
                .attr("cy", function (d) {
                    return y(d.metric1);
                })
                .style("fill", function (d) {
                    return d.dim3_name == 'accidents' ? "blue" : d.dim3_name == 'Fatal' ? "red" : d.dim3_name == 'Injuries' ? "orange" : metric1ColorScale(d.dim3_name);
                })
                //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                .on("mouseover", function (d) {
                    const fontColor = d.dim3_name == 'accidents' ? "blue" : d.dim3_name == 'Fatal' ? "red" : d.dim3_name == 'Injuries' ? "orange" : metric1ColorScale(d.dim3_name);
                    div1.transition()
                        .duration(200)
                        .style("opacity", .9);
                    div1.html(chart.x1MetricTooltip + colonAnnotation + formatTime(d.dim2_name) + "<br/>" +
                        chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                        chart.y1MetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                        chart.y2MetricTooltip + colonAnnotation + numberFormat(d.metric1))
                        .style("left", (d3.event.pageX) + "px")
                        .style("top", (d3.event.pageY - 28) + "px")
                        .style("color",fontColor);
                })
                .on("mouseout", function () {
                    div1.transition().duration(500).style("opacity", 0);
                });

            var y1legend = div.selectAll(".legend")
                .append("svg")
                .attr('class', 'legend')
                .data(function (d) {
                    return d.values
                })
                .enter()
                .append("g")
                .attr('transform', function (d, i) {                     // NEW
                    //  var height = 0;          // NEW
                    var horz = 140 * i;                       // NEW
                    var vert = 240;                        // NEW
                    return 'translate(' + horz + ',' + vert + ')';        // NEW
                });


            y1legend.append('circle')
                .attr('x', 5)
                .attr('y', chart.height + 2 * chart.margin.bottom)
                .attr("r", 5)
                .style('fill', function (d) {
                    return d.key == 'accidents' ? "blue" : d.key == 'Fatal' ? "red" : d.key == 'Injuries' ? "orange" : metric1ColorScale(d.key);
                });


            y1legend.append('text')
                .attr('x', 15)
                .attr('y', chart.height + 2 * chart.margin.bottom + 3)
                .attr('dy', '-30em')
                .style('font-size', '12px')
                .text(function (d) {
                    return d.key.substring(0, 20)
                })


            var zoomBehaviour = d3.zoom()
                .scaleExtent([1, 10])  // Define the zoom range (0.5x to 5x zoom)
                .on("zoom", zoomed);  // Attach the zoom event

            // Apply zoom to the SVG
            contentGroup.insert("rect","circle")
                .attr("width",chart.width)
                .attr("height",chart.height)
                .attr("fill","none")
                .attr("pointer-events","all")
                .call(zoomBehaviour);

            function zoomed(){
                var zoomState = d3.zoomTransform(this);
                console.log(zoomState);

                var newXScale = zoomState.rescaleX(x);
                var newYScale = zoomState.rescaleY(y);
                var newY2Scale = zoomState.rescaleY(y2);
                console.log("newYscale",newYScale);
                console.log("newY2Scale",newY2Scale);

                div.select('.x-axis').call(d3.axisBottom(newXScale).tickFormat(formatTime)).attr("transform", "translate(0," + chart.height + ")");
                div.select('.y1-axis').call(d3.axisLeft(newYScale).tickFormat(numberFormat));
                div.select('.y2-axis').call(d3.axisRight(newY2Scale).tickFormat(numberFormat));

                // Update the line path with the new x-scale
                contentGroup.selectAll(".line")
                    .attr('d', d => {
                        const path = d3.line()
                            .x(d => newXScale(d.dim2_name))
                            .y(d => newYScale(+d.metric1))
                        return path(d);
                    });

                // Update the second line path (if you have more lines)
                contentGroup.selectAll(".plotdashed")
                    .attr('d', d => {
                        let line2 = d3.line()
                            .x(d => newXScale(d.dim2_name))
                            .y(d => newY2Scale(+d.metric2))

                        return line2(d)
                    })

                // Update the circles (dots) to move accordingly
                contentGroup.selectAll(".dot")
                    .attr("cx", function (d) {
                        return newXScale(d.dim2_name);
                    })
                    .attr("cy", function (d) {
                        return newYScale(d.metric1);
                    })
                    .style("fill", function (d) {
                        return d.dim3_name == 'accidents' ? "blue" : d.dim3_name == 'Fatal' ? "red" : d.dim3_name == 'Injuries' ? "orange" : metric1ColorScale(d.dim3_name);
                    })
            }


        });
    // });
}
